import { useState, useEffect } from "react";
import styled from "styled-components";
import Input from "../components/shared/input";
import Button from "../components/shared/button";
import Form from "../components/shared/form";
import Checkbox from "../components/shared/checkbox";
import Objekt from "../components/Relationship";
import UserGreeting from "../components/Thanks";
import { Navigate } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";
import {
  getUser,
  setPersonalDetails,
  setLocationDetails,
  setRFIDOrder,
} from "../state/slices/userSlice";

import {
  getRegistrationCode,
  setRegistrationCode,
  setTarif,
} from "../state/slices/registrationSlice";

import axios from "axios";
import { useFormik } from "formik";
import * as yup from "yup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { anrede } from "../data/anrede";

const LogoSection = () => {
  return (
    <LogoContainer>
      <Logo src="/ca-immo-logo.jpg" />
    </LogoContainer>
  );
};

const HeaderSection = () => {
  return (
    <HeaderContainer>
      <Header></Header>
    </HeaderContainer>
  );
};

const FooterSection = () => {
  return (
    <FooterContainer>
      <ul class="footerMenu">
        <li>
          <a href="https://www.gcharge.de/impressum/">Impressum </a>
        </li>
        <li>Datenschutz</li>
        <li>Cookie-Einstellungen</li>
      </ul>
      <LogoContainer>
        <LogoG src="/powered-by-GCharge.png" />
      </LogoContainer>
    </FooterContainer>
  );
};

const GewerbeMessage = () => {
  return <div>Danke Ihre Registrierung war erfolgreich</div>;
};

const ErrorMitteilung = () => {
  return (
    <div>
      Ihre Registrierung war leider nicht erfolgreich. Wenden Sie sich an 0511
      51 949 440{" "}
    </div>
  );
};

const RelationshipForm = ({ setPage }) => {
  return (
    <RelationshipForm.Container>
      <Form title={"Bitte wählen Sie Ihr Objekt aus :"}>
        <Objekt
          objektName="One"
          beschreibung="Innovatives Bürohochhaus in Frankfurt am Main"
          onClick={() => setPage((page) => page + 1)}
        />
      </Form>
    </RelationshipForm.Container>
  );
};

const ObjektWelcome = ({ setPage }) => {
  const registrationCode = useSelector((state) => state.registrationCode);
  const dispatch = useDispatch();
  return (
    <RelationshipForm.Container>
      <div className="welcome-title">
        Herzlich Wilkommen im {registrationCode.objectIdentifier}
      </div>

      {/* <div className="image-wrapper">
        <img className="objekt-image" src={registrationCode.imageUrl} alt="" />
      </div> */}

      <Row>
        <BackButton onClick={() => setPage((page) => page - 1)}>
          Zurück
        </BackButton>
        <Button onClick={() => setPage((page) => page + 1)}>Weiter</Button>
      </Row>
    </RelationshipForm.Container>
  );
};

const UserTypeForm = ({ setPage }) => {
  const [no, setNo] = useState(true);

  return (
    <RelationshipForm.Container>
      {no && (
        <Form title={"Bitte wählen Sie aus:"}>
          <Objekt
            objektName="Privat"
            beschreibung="Ich möchte meinen privaten PKW laden"
            onClick={() => setPage((page) => page + 1)}
          />
          <Objekt
            objektName="Gewerbe"
            beschreibung="Ich möchte meinen Dienstwagen laden"
            onClick={() => {
              setNo(false);
            }}
          />
        </Form>
      )}
      {!no && (
        <div style={{ padding: "0 20px" }}>
          <RelationshipForm.Text>
            Bitte wenden Sie sich an Ihren zuständigen Ansprechpartner /
            Flottenmanager.
          </RelationshipForm.Text>
          <Button
            onClick={() => {
              setNo(true);
            }}
          >
            Zurück
          </Button>
        </div>
      )}
    </RelationshipForm.Container>
  );
};

const PersonalDetailsForm = ({ setPage }) => {
  const user = useSelector(getUser);
  const dispatch = useDispatch();

  const validationSchema = yup.object({
    email: yup
      .string("Geben Sie Ihre Emailaddresse ein")
      .email("Geben Sie eine bestehende Emailaddresse ein")
      .required("Emailaddresse wird benötigt"),
    nameFirst: yup
      .string("Enter your first name")
      .required("Vorname wird benötigt"),
    nameLast: yup
      .string("Enter your last name")
      .required("Nachname wird benötigt"),
    mobile: yup
      .string("Enter your phone number")
      .required("Telefonnummer wird benötigt"),
  });

  const formik = useFormik({
    initialValues: {
      nameFirst: user.nameFirst,
      nameLast: user.nameLast,
      email: user.email,
      mobile: user.mobile,
    },
    validateOnChange: true,
    validateOnBlur: true,
    validationSchema,
    onSubmit: (values) => {
      dispatch(setPersonalDetails({ ...values }));

      setPage((page) => page + 1);
    },
  });

  return (
    <Form
      title={"Bitte geben Sie Ihre persönlichen Daten ein:"}
      onSubmit={formik.handleSubmit}
    >
      <Row>
        <Input
          id={"nameFirst"}
          label={"Vorname"}
          placeholder={"Max"}
          value={formik.values.nameFirst}
          onChange={formik.handleChange}
          error={formik.errors.nameFirst && formik.touched.nameFirst}
          errorMessage={formik.errors.firstName}
          first={true}
        />
        <Input
          id={"nameLast"}
          label={"Nachname"}
          placeholder={"Mustermann"}
          value={formik.values.nameLast}
          onChange={formik.handleChange}
          error={formik.errors.nameLast && formik.touched.nameLast}
          errorMessage={formik.errors.nameLast}
        />
      </Row>
      <Row>
        <Input
          id={"email"}
          label={"E-Mail Adresse"}
          placeholder={"mail@abc.com"}
          value={formik.values.email}
          onChange={formik.handleChange}
          error={formik.errors.email && formik.touched.email}
          errorMessage={formik.errors.email}
        />
      </Row>
      <Row>
        <Input
          id={"mobile"}
          label={"Telefonnummer"}
          placeholder={"+492111234567"}
          value={formik.values.mobile}
          onChange={formik.handleChange}
          error={formik.errors.mobile && formik.touched.mobile}
          errorMessage={formik.errors.mobile}
        />
      </Row>
      <Row>
        <BackButton onClick={() => setPage((page) => page - 1)}>
          Zurück
        </BackButton>
        <Button loading={formik.isSubmitting}>Weiter</Button>
      </Row>
    </Form>
  );
};

const LocationDetailsForm = ({ setPage }) => {
  const user = useSelector(getUser);
  const dispatch = useDispatch();

  const validationSchema = yup.object({
    street: yup
      .string("Enter your address")
      .required("Adresse Zeile 1 wird benötigt"),
    additional: yup.string().optional(),
    city: yup.string("Enter your first name").required("Ort wird benötigt"),
    zipcode: yup
      .string("Enter your postal code")
      .required("Postleitzahl wird benötigt")
      .matches(
        /^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/,
        "Postleitzahl nicht gültig"
      ),
  });

  const formik = useFormik({
    initialValues: {
      street: user.address.line1,
      additional: user.address.line2,
      city: user.address.city,
      zipcode: user.address.zipcode,
    },
    validationSchema,
    onSubmit: (values) => {
      const payload = {
        street: values["street"],
        additional: values["additional"],
        city: values["city"],
        zipcode: values["zipcode"],
        country: "Deutschland",
      };

      dispatch(setLocationDetails({ ...payload }));

      setPage((page) => page + 1);
    },
  });

  return (
    <Form
      title={"Bitte geben Sie Ihre Adresse ein:"}
      onSubmit={formik.handleSubmit}
    >
      <Row>
        <Input
          id={"street"}
          label={"Straße und Hausnummer"}
          placeholder={"Willy-Brandt-Straße 1"}
          value={formik.values["street"]}
          onChange={formik.handleChange}
          error={formik.errors["street"] && formik.touched["street"]}
          errorMessage={formik.errors["street"]}
        />
      </Row>
      <Row>
        <Input
          id={"additional"}
          label={"Optionale Adresszeile"}
          value={formik.values["additional"]}
          onChange={formik.handleChange}
          error={formik.errors["additional"] && formik.touched["additional"]}
          errorMessage={formik.errors["additional"]}
        />
      </Row>
      <Row>
        <Input
          id={"zipcode"}
          label={"Postleitzahl"}
          placeholder={"10557"}
          value={formik.values.zipcode}
          onChange={formik.handleChange}
          error={formik.errors.zipcode && formik.touched.zipcode}
          errorMessage={formik.errors.zipcode}
        />
        <Input
          id={"city"}
          label={"Ort"}
          placeholder={"Berlin"}
          value={formik.values.city}
          onChange={formik.handleChange}
          error={formik.errors.city && formik.touched.city}
          errorMessage={formik.errors.city}
        />
      </Row>

      <Row>
        <BackButton onClick={() => setPage((page) => page - 1)}>
          Zurück
        </BackButton>
        <Button loading={formik.isSubmitting}>Weiter</Button>
      </Row>
    </Form>
  );
};

const QualificationForm = ({ setPage }) => {
  const registrationCode = useSelector((state) => state.registrationCode);
  const dispatch = useDispatch();

  const validationSchema = yup.object({
    "qualification-code": yup
      .string("Enter your qualificationcode")
      .test(
        "gib ein",
        "Dieser Qualificationscode ist uns nicht bekannt",
        (value) => {
          return new Promise((resolve, _) => {
            axios({
              method: "GET",
              url: `https://23qca4hdyl.execute-api.us-east-1.amazonaws.com/test/qualification`,
              // url: `https://virtserver.swaggerhub.com/taylant/GMS-Registration/1/qualification`,

              params: {
                code: value,
              },
            })
              .then((res) => {
                const { exists } = res.data["data"];
                // console.log(res.data);
                if (res.data["data"] === "") {
                  resolve(false);
                } else {
                  resolve(true);
                }
                dispatch(setRegistrationCode(res.data));
                dispatch(setTarif(res.data));
              })
              .catch((e) => resolve(false));
          });
        }
      )
      .required("Qualifikationscode wird benötigt"),
  });

  const formik = useFormik({
    initialValues: {
      "qualification-code": "",
    },
    validateOnChange: false,
    validateOnBlur: true,
    validationSchema,
    onSubmit: (values) => {
      const payload = {
        qualification: values["qualification-code"],
      };

      setPage((page) => page + 1);
    },
  });

  return (
    <Form
      title={"Bitte geben Sie Ihren Qualifikationscode ein:"}
      onSubmit={formik.handleSubmit}
    >
      <Row>
        <Input
          id={"qualification-code"}
          label={"Qualifikationscode"}
          value={formik.values["qualification-code"]}
          onChange={formik.handleChange}
          error={
            formik.errors["qualification-code"] &&
            formik.touched["qualification-code"]
          }
          errorMessage={formik.errors["qualification-code"]}
        />
      </Row>

      <Row>
        <BackButton onClick={() => setPage((page) => page - 1)}>
          Zurück
        </BackButton>
        <Button loading={formik.isSubmitting}>Weiter</Button>
      </Row>
      <Row></Row>
    </Form>
  );
};

const TermsOfUseForm = ({ setPage }) => {
  const registrationCode = useSelector((state) => state.registrationCode);
  const user = useSelector(getUser);
  const dispatch = useDispatch();
  useEffect(() => console.log(user), [user.wantHardware]);
  const validationSchema = yup.object({
    wantHardware: yup.boolean(),

    terms: yup
      .boolean()
      .required("Sie müssen die Allgemeinen Geschäftsbedingungen akzeptieren")
      .oneOf(
        [true],
        "Sie müssen die Allgemeinen Geschäftsbedingungen akzeptieren"
      ),
    widerruf: yup
      .boolean()
      .oneOf(
        [true],
        "Sie müssen bestätigen, dass Sie die Widerufsbelehrung erhalten haben"
      ),
    contract: yup
      .boolean()
      .required("Sie müssen bestätigen, dsdfsdf.")
      .oneOf(
        [true],
        "Sie müssen bestätigen, dass Sie die Tarifdetails gespeichert haben. "
      ),
  });

  const formik = useFormik({
    initialValues: {
      terms: false,
      widerruf: false,
      contract: false,
      wantHardware: false,
    },

    validationSchema,

    onSubmit: (values) => {
      dispatch(setRFIDOrder({ ...values }));

      //console.log();
      return new Promise((resolve, _) => {
        axios({
          method: "POST",
          url: `https://23qca4hdyl.execute-api.us-east-1.amazonaws.com/test/customer`,
          data: JSON.stringify(user),
        })
          .then((res) => {
            formik.setSubmitting(false);
            setPage((page) => page + 1);
          })
          .catch((e) => {
            console.log(e);
            resolve(false);
            setPage((page) => page + 2);
          });
      });

      setSuccess(true);
      console.log(success);
    },
  });

  return (
    <Form title={"Tarife und Gebühren:"} onSubmit={formik.handleSubmit}>
      <ContractRecap>
        <div className="flexItem">Einrichtungsgebühr</div>
        <div className="flexPrice">0 €</div>
        <div className="flexItem">Monatliche Grundgebühr</div>
        <div className="flexPrice">{registrationCode.monthlyFee} €</div>
        <div className="flexItem">Arbeitspreis</div>
        <div className="flexPrice">{registrationCode.acKWh} €/kWh</div>
        <div className="flexItem">Zeittarif</div>
        <div className="flexPrice">0 €/Minute</div>
        <div className="flexItem">RFID Karte</div>
        <div className="flexPrice">10.00 € (inkl. Versand)</div>
      </ContractRecap>
      <CheckboxContainer>
        <CheckboxLine>
          <Checkbox
            id={"wantHardware"}
            value={formik.values["wantHardware"]}
            onChange={formik.handleChange}
            error={
              formik.errors["wantHardware"] && formik.touched["wantHardware"]
            }
            errorMessage={formik.errors["wantHardware"]}
          >
            <span>
              Ich möchte eine RFID Karte, gemäß Tarifdetails, bestellen.
            </span>
          </Checkbox>
        </CheckboxLine>
      </CheckboxContainer>
      <CheckboxContainer>
        <CheckboxLine>
          <Checkbox
            id={"contract"}
            value={formik.values["contract"]}
            onChange={formik.handleChange}
            error={formik.errors["contract"] && formik.touched["contract"]}
            errorMessage={formik.errors["contract"]}
          >
            <span>
              Ich nehme die anfallenden Gebühren und den aktuell gültigen Tarif
              zur Kentniss und bin mir bewusst, dass sich der Tarif entsprechend
              den AGBs ändern kann.
            </span>
            <a href="/Preisblatt_CAImmo.pdf">
              Download der Vertrags-und Tarifbedingungen
            </a>
          </Checkbox>
        </CheckboxLine>
      </CheckboxContainer>

      <CheckboxContainer>
        <div className="title">Allgemeine Geschäftsbedingungen</div>
        <CheckboxLine>
          <Checkbox
            id={"terms"}
            value={formik.values["terms"]}
            onChange={formik.handleChange}
            error={formik.errors["terms"] && formik.touched["terms"]}
            errorMessage={formik.errors["terms"]}
          >
            <span>
              Hiermit akzeptiere ich die allgemeinen{" "}
              <a
                target="_blank"
                rel="noreferrer"
                href={`https://registrationpage-ca-immo.s3.amazonaws.com/static/pdfs/Allgemeine+Gescha%CC%88ftsbedingungen+GETEC+mobility+Solutions+GmbH.pdf`}
              >
                Geschäftsbedingungen
              </a>{" "}
              des E-Mobility Betriebsservice.
            </span>
          </Checkbox>
        </CheckboxLine>
      </CheckboxContainer>
      <CheckboxContainer>
        <CheckboxLine>
          <Checkbox
            id={"widerruf"}
            value={formik.values["widerruf"]}
            onChange={formik.handleChange}
            error={formik.errors["widerruf"] && formik.touched["widerruf"]}
            errorMessage={formik.errors["widerruf"]}
          >
            <span>
              Der Download oder der Ausdruck der{" "}
              <a target="_blank" rel="noreferrer" href="/Formular-Widerruf.pdf">
                Widerrufsbelehrung
              </a>{" "}
              war erfolgreich
            </span>
          </Checkbox>
        </CheckboxLine>
      </CheckboxContainer>

      <Row>
        <BackButton
          onClick={() =>
            setPage((page) => {
              return page - 1;
            })
          }
        >
          Zurück
        </BackButton>
        <Button loading={formik.isSubmitting}>Abschließen</Button>
      </Row>
    </Form>
  );
};

RelationshipForm.Container = styled.div`
  max-width: 420px;
  width: 100%;

  .welcome-title {
    font-size: 26px;
    text-align: center;
    margin-bottom: 1em;
    color: gray;
  }
  .objekt-image {
    width: 50%;
    margin: auto;
    display: block;
  }
  .image-wrapper {
    max-width: 420px;
    margin-bottom: 1em;
  }
`;

RelationshipForm.Text = styled.span`
  font-size: 26px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 32px;
  display: block;
  color: #85181d;
`;
LocationDetailsForm;
const RegisterPage = () => {
  const [page, setPage] = useState(0);

  return (
    <Container>
      <LogoSection />
      <Stepper page={page} maxPage={5} />
      <HeaderSection />
      {/* {page === 0 && <RelationshipForm setPage={setPage} />} */}
      {page === 0 && <UserTypeForm setPage={setPage} />}

      {page === 1 && <QualificationForm setPage={setPage} />}
      {page === 2 && <ObjektWelcome setPage={setPage} />}
      {page === 3 && <PersonalDetailsForm setPage={setPage} />}
      {page === 4 && <LocationDetailsForm setPage={setPage} />}
      {page === 5 && <TermsOfUseForm setPage={setPage} />}
      {page === 6 && <GewerbeMessage setPage={setPage} />}
      {page === 7 && <ErrorMitteilung setPage={setPage} />}
      <FooterSection />
    </Container>
  );
};

export const Stepper = ({ page, maxPage }) => {
  const get = () => {
    const elems = [];
    for (let i = 0; i <= maxPage; i++) {
      elems.push(
        <>
          <div className="step-title" active={i <= page}>
            <StepperTitleNumber
              className="step-title-number"
              active={i <= page}
            />
          </div>
          {i < maxPage && (
            <StepperProgressBar
              className="stepper-progress-bar"
              active={i <= page}
            />
          )}
        </>
      );
    }

    return elems;
  };

  return (
    <StepperWrapper>
      <div className="stepper-wrapper">
        <div className="stepper-progress">
          <div className="stepper-progress-wrapper">{get()}</div>
        </div>
      </div>
    </StepperWrapper>
  );
};

const StepperWrapper = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 13px;

  .step-wrapper {
    width: 600px;
    height: 100%;
  }

  .stepper-selector {
    position: absolute;
    top: 0;
    height: 100%;
    display: inline-flex;
    /* Animate each step movement */
    transition: transform 1s cubic-bezier(0.23, 1, 0.32, 1) 0s;
  }

  .stepper-progress {
    display: flex;
    justify-content: center;
  }

  .stepper-progress-wrapper {
    width: 90%;
    position: relative;
    display: flex;
    margin: auto;
    justify-content: center;
    align-items: center;
  }

  .step-title {
    text-align: center;
    font-size: 0.7rem;
    align-items: center;
    background: #fff;
    /* padding: 0 1rem; */
    /* height: 30px; */
  }
`;

const StepperProgressBar = styled.div`
  width: 10%;
  max-width: 40px;
  height: 1px;
  top: 12px;
  z-index: -1;
  background: ${(props) => (props.active ? "#85181D; " : "#B9B9C3")};
  transition: width 1s cubic-bezier(0.23, 1, 0.32, 1) 0s;
  margin: 0 2px;
`;

const StepperTitleNumber = styled.div`
  font-size: 1rem;
  background: ${(props) => (props.active ? "#85181D" : "#fff")};
  height: 12px;
  width: 12px;
  margin: 0.3rem auto;
  line-height: 1.5;
  border: ${(props) => (props.active ? "none" : "1px solid #B9B9C3")};
  border-radius: 100%;
`;

export default RegisterPage;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 811px;
  margin: 75px auto 184px auto;
  position: relative;

  @media only screen and (max-width: 800px) {
    margin: auto;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 30px 0 15px 0;
`;

const Logo = styled.img`
  width: 150px;
`;
const LogoG = styled.img`
  width: 120px;
`;

const HeaderContainer = styled.div`
  text-align: center;
  margin-bottom: 20px;
`;

const Header = styled.h1`
  color: #525252;
  font-size: 30px;
  line-height: 36px;
  font-weight: 700;
  margin: 0;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  margin-bottom: 24px;
  gap: 20px;
  position: relative;
`;

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 25px;

  .title {
    color: #525252;
    font-size: 16px;
    font-weight: 400;
    line-height: 21.82px;
    margin: 0 0 18px 0;
  }
`;

const CheckboxLine = styled.div`
  margin: 6px 0;
  display: flex;
  align-items: flex-start;
`;

const Select = styled.select`
  border: 1px solid #ded2d9;
  border-radius: 5px;
  color: #525252;
  font-size: 14px;
  font-weight: 400;
  line-height: 19.1px;
  padding: 13px 10px;
  height: 45px;
  width: 100%;
  background-color: #fff;

  :focus {
    outline: none;
    border: 1px solid #85181d;
  }

  ${(props) => {
    if (props.error) {
      return `
        border: 1px solid red;
      `;
    }
  }}
`;

const Option = styled.option``;

Select.ErrorMessage = styled.span`
  position: absolute;
  top: 68px;
  left: 0px;
  font-size: 10px;
  color: red;
`;

const BackButton = styled(Button)`
  background-color: #525252;
  opacity: 0.7;
`;

const ContractRecap = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 80%;
  margin: auto;

  .flexItem {
    box-sizing: border-box;
    flex: auto;
    height: 2em;
    min-width: 50%;
    font-size: 14px;
  }

  .flexPrice {
    text-align: right;
    box-sizing: border-box;
    height: 2em;
    flex: auto;
    font-size: 14px;
  }
`;

const FooterContainer = styled.div`
  li {
    display: inline;
    margin: 1em;
    font-size: 12px;
    color: gray;
  }
`;
